import { useState } from "react"
import dynamic from "next/dynamic"
import { Flex } from "@chakra-ui/react"
import CrfErrorBoundary from "components/error/CrfErrorBoundary"
import Header from "components/layouts/tct2025/headerTct2025alt"
import Footer from "./footerLatam2026"
import SeoMetaFields from "components/header/seoMetaFields"
import SocialMediaSection from "components/ui/SocialMediaSection"
import PageContent from "components/layout/pageContent"

const AppLayout = dynamic(() => import("components/layouts/app/appLayout"))

export default function LayoutLatam2026(props) {
    return (
        <LayoutWrapper {...props}>
            <CrfErrorBoundary>
                <PageContent
                    page={props.page}
                    matrix={props.matrix}
                    site={props.site}
                    user={props.user}
                    colorMode={props.colorMode}
                    channels={props.channels}
                    sessionTypes={props.sessionTypes}
                    sessionId={props.sessionId}
                    presentationId={props.presentationId}
                    facetsConfig={props.facetsConfig}
                    craftSiteId={props.craftSiteId}
                    showPageHeader={false}
                >
                    {props.children}
                </PageContent>
            </CrfErrorBoundary>
        </LayoutWrapper>
    )
}

function LayoutWrapper({ children, ...props }) {
    const [topMargin, setTopMargin] = useState("104px")

    // handles "app" layout variant
    if (props.layoutVariant === "app") return <AppLayout {...props}>{children}</AppLayout>

    const onViewportChange = (showMobileMenu, offset) => {
        setTopMargin(showMobileMenu ? offset : 0) // height of menu bar
    }

    const _hideSocialFooter = props.hideSocialFooter || props.site?.meeting?.hideSocialFooter || false

    // an ad set on the page overrides the global site ad
    // const resolvedAd = props.pageAd ? props.pageAd : props.site?.meeting?.ad
    return (
        <Flex direction="column" minHeight="100vh" bg="color5" className={props.className} {...props.bgStyles}>
            <Header site={props.site} hideNav={props.hideNav} onViewportChange={onViewportChange} />

            {/*{!props.hideAd && resolvedAd ? (*/}
            {/*    <Ad block={{ adUnit: resolvedAd }} mt={0} pb={0} bg="transparent" />*/}
            {/*) : null}*/}

            <Flex className="pageBody" flexGrow={1} direction="column" marginTop={topMargin}>
                <SeoMetaFields page={props.page} />
                {children}
            </Flex>

            {!_hideSocialFooter && props.socialFooterText && (
                <SocialMediaSection text={props.socialFooterText} className="socialFooter" textAlign="center" />
            )}

            <Footer />
        </Flex>
    )
}
